// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uK7Voq3WQSzBrV {
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: left;
  padding: 26px var(--ds-space-400, 32px) 26px var(--ds-space-600, 48px);
}
@media only screen and (max-width: 750px) {
  .uK7Voq3WQSzBrV {
    padding: 26px var(--ds-space-400, 32px);
  }
}
.EIfg5OYh8VVHL9 {
  margin: var(--ds-space-0, 0) var(--ds-space-600, 48px);
}
@media only screen and (max-width: 750px) {
  .EIfg5OYh8VVHL9 {
    margin: var(--ds-space-0, 0) var(--ds-space-400, 32px);
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerWrapperMember": `uK7Voq3WQSzBrV`,
	"tabWrapper": `EIfg5OYh8VVHL9`
};
export default ___CSS_LOADER_EXPORT___;
